import { Box, Container, Flex, Text, Image, Divider, SimpleGrid, Input, InputGroup, FormControl, FormLabel, Textarea, Select, InputLeftElement, ButtonGroup, Button, Center, Heading, IconButton, FormErrorMessage, Checkbox, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import AuthService from "services/auth/auth-service";
import Layout from "scenes/layouts";
import { FiFacebook, FiGlobe, FiInstagram, FiTwitter } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik, useFormik } from "formik";
import LogosNotification from "utils/notification-utils";
import { EditIcon } from "@chakra-ui/icons";
import { relative } from "path";
import { BsPencil } from "react-icons/bs";
import AppConsts from "libs/appconst";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import ConfirmDialog from "../../components/confirm-dialog";
import TimePicker from "react-time-picker";

const formInitialValue = {
    name: '',
    voucherCode: '',
    isPercentage: '',
    value: '',
    isCanExpire: '',
    expiryDate: '',
    isForAllProgram: '',
    programId: '',
    isHaveRestriction: '',
    restrictionProgramId: '',
    isActive: true
};

const EditVoucher = (): ReactElement => {
    const navigate = useNavigate();
    const { voucherId } = useParams();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [voucher, setVoucher] = useState<any>(null);
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [programs, setPrograms] = useState<any>([]);
    const { isOpen: isShowDeleteDialog, onOpen: onShowDeleteDialog, onClose: onCloseDeleteDialog } = useDisclosure();
    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [time, setTime] = useState<any>(null);

    useEffect(() => {
        setLoading(true);

        ProgramService.GetAllProgram().then((programRes: any) => {
            setPrograms(programRes.result);

            VoucherService.Get(voucherId).then((res: any) => {
                setVoucher(res.result);
                var values = res.result;
                values.value = res.result.isPercentage ? (res.result.value * 100).toFixed(0) : res.result.value;
                values.programId = res.result.isForAllProgram ? null : res.result.program.id;
                values.restrictionProgramId = res.result.isHaveRestriction ? res.result.restrictProgram.id : null;
                values.expiryDate = !res.result.expiryDate ? new Date() : new Date(res.result.expiryDate);
                setFormValue(values);

                var time = !res.result.expiryDate ? '23:59' : values.expiryDate.getHours() + ':' + values.expiryDate.getMinutes();
                setTime(time);

            }).finally(() => {
                setLoading(false);
            });
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        VoucherService.Update(
            voucherId,
            values.name,
            values.voucherCode,
            values.isPercentage,
            values.isPercentage ? values.value / 100 : values.value,
            values.isCanExpire,
            values.expiryDate,
            time,
            values.isForAllProgram,
            values.programId,
            values.isHaveRestriction,
            values.restrictionProgramId,
            values.isActive
            //dateOfBirth: new Date(values.dateOfBirthYear, values.dateOfBirthMonth, values.dateOfBirthDay)
        ).then((res: any) => {
            LogosNotification.Success("Voucher berhasil diperbaharui.");
            navigate('/vouchers');
        }).finally(() => {
            setSaving(false);
        });
    };

    const handleDeleteVoucher = () => {
        setIsDeleting(true);
        VoucherService.Delete(voucherId).then((res: any) => {
            LogosNotification.Success("Voucher telah berhasil dihapuskan.");
            navigate("/vouchers");
        }).finally(() => {
            setIsDeleting(false);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Edit Voucher {voucher.name}</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama Voucher</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Voucher'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Voucher wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} py={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.voucherCode && touched.voucherCode)}>
                                                    <FormLabel htmlFor='voucherCode'>Kode Voucher</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='voucherCode'
                                                        placeholder='Kode Voucher'
                                                        name={'voucherCode'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Kode Voucher wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.voucherCode}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.isPercentage && touched.isPercentage)}>
                                                    <FormLabel htmlFor='isPercentage'>Apakah dalam Persentase?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='isPercentage'
                                                        name={'isPercentage'}
                                                        checked={values.isPercentage}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.isPercentage}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pb={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.value && touched.value)}>
                                                    <FormLabel htmlFor='value'>Nilai Diskon ({values.isPercentage ? "%" : "Rupiah"})</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='value'
                                                        placeholder='Nilai Diskon'
                                                        name={'value'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nilai Diskon wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.value}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isCanExpire && touched.isCanExpire)}>
                                                        <FormLabel htmlFor='isCanExpire'>Ada Tanggal Kadarluasa?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isCanExpire'
                                                            name={'isCanExpire'}
                                                            checked={values.isCanExpire}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isCanExpire}</FormErrorMessage>
                                                    </FormControl>
                                                    {
                                                        values.isCanExpire &&
                                                        <Box>
                                                            <FormControl isRequired isInvalid={!!(errors.expiryDate && touched.expiryDate)} mt={1}>
                                                                <FormLabel htmlFor='value'>Tanggal Kadarluasa</FormLabel>
                                                                <SingleDatepicker
                                                                    id='expiryDate'
                                                                    name='expiryDate'
                                                                    date={values.expiryDate}
                                                                    onDateChange={(date: Date) => {
                                                                        setFieldValue("expiryDate", date);
                                                                    }}
                                                                />
                                                                <FormErrorMessage>{errors.expiryDate}</FormErrorMessage>
                                                            </FormControl>

                                                            <FormControl mt={2}>
                                                                <TimePicker onChange={(time: any) => setTime(time)} value={time} format={"HH:mm"} />
                                                            </FormControl>
                                                        </Box>
                                                    }

                                                </Box>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isForAllProgram && touched.isForAllProgram)}>
                                                        <FormLabel htmlFor='isCanExpire'>Semua Program?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isForAllProgram'
                                                            name={'isForAllProgram'}
                                                            checked={values.isForAllProgram}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isForAllProgram}</FormErrorMessage>
                                                    </FormControl>
                                                    {
                                                        values.isForAllProgram && <FormControl></FormControl>
                                                    }
                                                    {
                                                        !values.isForAllProgram &&
                                                        <FormControl isRequired isInvalid={!!(errors.programId && touched.programId)} mt={1}>
                                                            <FormLabel htmlFor='value'>Program</FormLabel>
                                                            <Field as={Select} id='programId' placeholder='Pilih Program' name={'programId'}
                                                                validate={(value: any) => {
                                                                    let error;
                                                                    if (!value)
                                                                        error = "Silahkan pilih Program";
                                                                    return error;
                                                                }}>
                                                                {
                                                                    programs.map((program: any) => {
                                                                        return <option value={program.id}>{program.name}</option>;
                                                                    })
                                                                }
                                                            </Field>
                                                            <FormErrorMessage>{errors.programId}</FormErrorMessage>
                                                        </FormControl>
                                                    }

                                                </Box>

                                                <Box>
                                                    <FormControl isRequired isInvalid={!!(errors.isHaveRestriction && touched.isHaveRestriction)}>
                                                        <FormLabel htmlFor='isCanExpire'>Bisa digunakan Jika sudah punya Program?</FormLabel>
                                                        <Field
                                                            type="checkbox"
                                                            id='isHaveRestriction'
                                                            name={'isHaveRestriction'}
                                                            checked={values.isHaveRestriction}
                                                            style={{ width: '22px', height: '22px' }}
                                                        >
                                                        </Field>
                                                        <FormErrorMessage>{errors.isHaveRestriction}</FormErrorMessage>
                                                    </FormControl>
                                                    {
                                                        !values.isHaveRestriction && <FormControl></FormControl>
                                                    }
                                                    {
                                                        values.isHaveRestriction &&
                                                        <FormControl isRequired isInvalid={!!(errors.restrictionProgramId && touched.restrictionProgramId)} mt={1}>
                                                            <FormLabel htmlFor='value'>Jika punya Program</FormLabel>
                                                            <Field as={Select} id='restrictionProgramId' placeholder='Pilih Program' name={'restrictionProgramId'}
                                                                validate={(value: any) => {
                                                                    let error;
                                                                    if (!value)
                                                                        error = "Silahkan pilih Program";
                                                                    return error;
                                                                }}>
                                                                {
                                                                    programs.map((program: any) => {
                                                                        return <option value={program.id}>{program.name}</option>;
                                                                    })
                                                                }
                                                            </Field>
                                                            <FormErrorMessage>{errors.restrictionProgramId}</FormErrorMessage>
                                                        </FormControl>
                                                    }

                                                </Box>

                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} pt={4} mb={1}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.isActive && touched.isActive)}>
                                                    <FormLabel htmlFor='isActive'>Aktif?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='isActive'
                                                        name={'isActive'}
                                                        checked={values.isActive}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.isActive}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />
                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} colorScheme={'red'} isLoading={isDeleting} onClick={onShowDeleteDialog}>Hapus</Button>
                                                <Button variant={'outline'} onClick={() => { navigate('/vouchers') }}>Kembali</Button>
                                            </ButtonGroup>
                                            {
                                                isShowDeleteDialog &&
                                                <ConfirmDialog
                                                    title={'Hapus Voucher'}
                                                    message={`Apakah Anda yakin untuk menghapus Voucher ${voucher.voucherCode}?`}
                                                    colorScheme={'red'}
                                                    buttonLabel={'Yakin'}
                                                    onSubmit={handleDeleteVoucher}
                                                    onClose={onCloseDeleteDialog}
                                                    isLoading={isDeleting}
                                                />
                                            }
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default EditVoucher;